var TyrePdp = (function () {

    function loadTyreSizes(tyreSizePdpTextContainer, tyreProductFullSize) {
        return function (data) {
            var tyreSizesSelect = $("<select>")
                .addClass("tyre-product-sizes-select-pdp")
                .on('change', function () {
                    location.href = this.value;
                });

            data.forEach(function (tyre) {
                var option = $("<option>").prop("value", tyre.url).text(tyre.fullSize);

                if (tyre.fullSize === tyreProductFullSize) {
                    option.prop("selected", true);
                }

                tyreSizesSelect.append(option);
            });

            $(".tyre-product-full-size-text-pdp").remove();
            tyreSizePdpTextContainer.replaceWith(tyreSizesSelect);
        };
    }

    function initializeTyreSizeChange() {
        var tyreSizePdpTextContainer = $(".tyre-product-size-pdp-link");
        tyreSizePdpTextContainer.on('click', function () {
            var tyreProductFullSize = $(".tyre-product-full-size-text-pdp").first().text();

            var payload = {
                brand: $("#tyre-product-brand").val(),
                name: $("#tyre-product-name").val(),
                season: $("#tyre-product-season").val(),
                vehicleType: $("#tyre-product-vehicle-type").val(),
                vehicleSubType: $("#tyre-product-vehicle-sub-type").val()
            };

            $.ajax({
                url: "/search/tyre/sizes",
                type: "GET",
                cache: false,
                data: payload
            }).done(loadTyreSizes(tyreSizePdpTextContainer, tyreProductFullSize));
        });
    }

    function initializePriceAsteriskLink() {
        var priceAsteriskLinkContainer = $(".productDetailComponent .price-asterisk-link-container").first();
        var freeShippingAsteriskLink = $(".shop-advantages .FREE_SHIPPING .asterisks").first();
        if (!priceAsteriskLinkContainer.length || !freeShippingAsteriskLink.length
            || !freeShippingAsteriskLink.is(":visible")) {
            return;
        }

        var text = freeShippingAsteriskLink.text();
        var href = freeShippingAsteriskLink.attr("href");
        var priceAsteriskLink = $("<a>").attr("href", href).text(text);
        priceAsteriskLinkContainer.append(priceAsteriskLink);
    }

    function initializeShowSuitableTubesLink() {
        var showSuitableTubesLink = $(".pdp-tyre-product-show-suitable-tubes-link");
        if (!showSuitableTubesLink.length) {
            return;
        }

        var pdpCrossSellingJcarousel = $("#pdpCrossSellingJcarousel");
        if (!pdpCrossSellingJcarousel.length) {
            $(".pdp-tyre-product-show-suitable-tubes-container").hide();
            return;
        }

        showSuitableTubesLink.on('click', function () {
            $("html, body").animate({
                scrollTop: pdpCrossSellingJcarousel.offset().top
            }, 500);
        });
    }

    function initialize() {
        initializeTyreSizeChange();
        initializePriceAsteriskLink();
        initializeShowSuitableTubesLink();
    }

    return {
        initialize: initialize
    };

})();

$(function () {
    TyrePdp.initialize();
});